import Vue from 'vue';
import Vuex from 'vuex';
import User from '@/store/modules/User';
import Lookup from '@/store/modules/Lookup';
import Client from '@/store/modules/Client';

Vue.use(Vuex);

const store = new Vuex.Store({
  debug: process.env.NODE_ENV !== 'production',
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    User,
    Lookup,
    Client,
  },
});

export default store;
